module.exports = __webpack_public_path__ + "img/cancel-icon.f7391197.svg";